<mat-form-field class="w-100-p" appearance="outline">
  <mat-label>บริษัท</mat-label>
  <mat-select #selectModel="ngModel" [(ngModel)]="input" [disabled]="disabled" (selectionChange)="onSelectItem($event)"  (ngModelChange)="onChange(input);">
    <mat-option *ngFor="let company of companys" [value]="company.id">
      {{ company.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
